<template>
  <el-form-item v-if="sections && sections.length > 0" label="Section" prop="section_id">
    <el-select-v2 v-model="sectionId" placeholder="Select Section" :options="sections" style="width: 100%"
      @change="$emit('selected-section-id', sectionId)" />
  </el-form-item>
</template>

<script>
import { ref, watch } from "vue";
import store from "@/store";

export default {
  name: "SectionDropdownV2",
  props: {
    allowAll: {
      type: Boolean,
      default: true,
    },
    selected: {
      type: Number,
      default: -1,
    },
  },
  emits: ["selected-section-id"],
  setup(props) {
    let sectionId = ref(props.selected);
    if (sectionId.value == -1 && !props.allowAll) {
      sectionId.value = "";
    }

    watch(
      () => props.selected,
      (current) => {
        if (current == -1 && !props.allowAll) sectionId.value = "";
        else sectionId.value = current;
      }
    );
    return { sectionId };
  },
  data() {
    return {
      sections: [],
    };
  },
  created() {
    store
      .dispatch("list/getSections", { sort: "name", order: "asc" })
      .then((res) => {

        let sectionsList = [];
        if (res.data && res.data.length > 0) {
          for (let data of res.data) {
            sectionsList.push({ value: data.section_id, label: data.name })
          }
        }
        this.sections = sectionsList;
        if (this.allowAll) {
          this.sections.unshift({ value: -1, label: "All Sections" });
        }
      });
  },
};
</script>

<style></style>